import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "quizzes-page" };
const _hoisted_2 = { class: "alert-message" };
const _hoisted_3 = { class: "quizzes-container" };
const _hoisted_4 = { class: "quiz-info" };
const _hoisted_5 = { class: "quiz-name" };
const _hoisted_6 = { class: "quiz-meta" };
const _hoisted_7 = { class: "question-count" };
const _hoisted_8 = {
    key: 0,
    class: "quiz-details-section"
};
const _hoisted_9 = { class: "section-header" };
const _hoisted_10 = { class: "header-actions-group" };
const _hoisted_11 = {
    key: 0,
    class: "started-warning"
};
const _hoisted_12 = {
    key: 1,
    class: "json-editor-section"
};
const _hoisted_13 = {
    key: 0,
    class: "json-error"
};
const _hoisted_14 = {
    key: 2,
    class: "details-grid"
};
const _hoisted_15 = { class: "form-section" };
const _hoisted_16 = { class: "form-group" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = { class: "form-row" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = { class: "form-row" };
const _hoisted_22 = { class: "form-group" };
const _hoisted_23 = { class: "form-group" };
const _hoisted_24 = { class: "input-with-button" };
const _hoisted_25 = ["disabled"];
const _hoisted_26 = { class: "form-row" };
const _hoisted_27 = { class: "form-group" };
const _hoisted_28 = { class: "form-row" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = { class: "form-section" };
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = { class: "input-with-button" };
const _hoisted_34 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_35 = ["src"];
const _hoisted_36 = { class: "form-group" };
const _hoisted_37 = { class: "input-with-button" };
const _hoisted_38 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_39 = ["src"];
const _hoisted_40 = { class: "form-group" };
const _hoisted_41 = { class: "input-with-button" };
const _hoisted_42 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_43 = ["src"];
const _hoisted_44 = { class: "form-group" };
const _hoisted_45 = { class: "input-with-button" };
const _hoisted_46 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = { class: "form-group" };
const _hoisted_49 = { class: "form-section" };
const _hoisted_50 = { class: "form-group" };
const _hoisted_51 = { class: "form-group" };
const _hoisted_52 = { class: "form-group" };
const _hoisted_53 = { class: "form-section" };
const _hoisted_54 = { class: "form-row" };
const _hoisted_55 = { class: "form-group" };
const _hoisted_56 = { class: "form-group" };
const _hoisted_57 = { class: "form-section" };
const _hoisted_58 = { class: "employers-list" };
const _hoisted_59 = ["value"];
const _hoisted_60 = { class: "form-section full-width" };
const _hoisted_61 = { class: "section-header" };
const _hoisted_62 = {
    key: 0,
    class: "questions-list"
};
const _hoisted_63 = ["onDragstart", "onDragover", "onDrop"];
const _hoisted_64 = ["onClick"];
const _hoisted_65 = { class: "question-number" };
const _hoisted_66 = { class: "question-preview" };
const _hoisted_67 = ["onClick"];
const _hoisted_68 = ["onClick"];
const _hoisted_69 = {
    key: 0,
    class: "question-details"
};
const _hoisted_70 = { class: "form-row" };
const _hoisted_71 = { class: "form-group" };
const _hoisted_72 = ["onUpdate:modelValue"];
const _hoisted_73 = { class: "form-group" };
const _hoisted_74 = ["onUpdate:modelValue"];
const _hoisted_75 = { class: "form-group" };
const _hoisted_76 = ["onUpdate:modelValue"];
const _hoisted_77 = { class: "form-group" };
const _hoisted_78 = ["onUpdate:modelValue"];
const _hoisted_79 = { class: "form-group" };
const _hoisted_80 = ["onUpdate:modelValue"];
const _hoisted_81 = { class: "form-group" };
const _hoisted_82 = ["onUpdate:modelValue"];
const _hoisted_83 = { class: "form-group" };
const _hoisted_84 = ["onUpdate:modelValue"];
const _hoisted_85 = { class: "form-group" };
const _hoisted_86 = ["onUpdate:modelValue"];
const _hoisted_87 = { class: "form-row" };
const _hoisted_88 = { class: "form-group" };
const _hoisted_89 = ["onUpdate:modelValue"];
const _hoisted_90 = { class: "form-group" };
const _hoisted_91 = ["onUpdate:modelValue"];
const _hoisted_92 = { class: "form-row" };
const _hoisted_93 = { class: "form-group" };
const _hoisted_94 = { class: "input-with-button" };
const _hoisted_95 = ["onUpdate:modelValue"];
const _hoisted_96 = ["onClick"];
const _hoisted_97 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_98 = ["src"];
const _hoisted_99 = { class: "form-group" };
const _hoisted_100 = { class: "input-with-button" };
const _hoisted_101 = ["onUpdate:modelValue"];
const _hoisted_102 = ["onClick"];
const _hoisted_103 = {
    key: 0,
    class: "image-preview-container"
};
const _hoisted_104 = ["src"];
const _hoisted_105 = { class: "answers-section" };
const _hoisted_106 = { class: "answers-list" };
const _hoisted_107 = ["onUpdate:modelValue"];
const _hoisted_108 = { class: "checkbox-label" };
const _hoisted_109 = ["onUpdate:modelValue"];
const _hoisted_110 = ["onClick"];
const _hoisted_111 = ["onClick"];
const _hoisted_112 = {
    key: 1,
    class: "empty-state-small"
};
const _hoisted_113 = { class: "form-section full-width" };
const _hoisted_114 = { class: "section-header" };
const _hoisted_115 = {
    key: 0,
    class: "prizes-table"
};
const _hoisted_116 = ["onUpdate:modelValue"];
const _hoisted_117 = ["onUpdate:modelValue"];
const _hoisted_118 = ["onUpdate:modelValue"];
const _hoisted_119 = ["onUpdate:modelValue"];
const _hoisted_120 = ["onClick"];
const _hoisted_121 = {
    key: 1,
    class: "empty-state-small"
};
const _hoisted_122 = { class: "form-section" };
const _hoisted_123 = { class: "form-row" };
const _hoisted_124 = { class: "form-group" };
const _hoisted_125 = { class: "form-group" };
const _hoisted_126 = { class: "form-row" };
const _hoisted_127 = { class: "form-group" };
const _hoisted_128 = { class: "form-group" };
const _hoisted_129 = {
    key: 0,
    class: "form-section"
};
const _hoisted_130 = { class: "form-row" };
const _hoisted_131 = { class: "form-group" };
const _hoisted_132 = { class: "form-group" };
const _hoisted_133 = ["disabled"];
const _hoisted_134 = {
    key: 0,
    class: "warning-text"
};
const _hoisted_135 = {
    key: 1,
    class: "empty-state-section"
};
const _hoisted_136 = { class: "modal-header" };
const _hoisted_137 = { class: "modal-body" };
const _hoisted_138 = { class: "modal-footer" };
const _hoisted_139 = { class: "modal-header" };
const _hoisted_140 = { class: "modal-body" };
const _hoisted_141 = { class: "search-box" };
const _hoisted_142 = {
    key: 0,
    class: "file-grid"
};
const _hoisted_143 = ["onClick"];
const _hoisted_144 = { class: "file-preview" };
const _hoisted_145 = ["src", "alt"];
const _hoisted_146 = { class: "file-card-info" };
const _hoisted_147 = ["title"];
const _hoisted_148 = {
    key: 1,
    class: "empty-state-small"
};
const _hoisted_149 = ["disabled"];
import { ref, computed, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
import MGDialog from '@/components/elements/MGDialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QuizzesPage',
    setup(__props) {
        const admin = useAdmin();
        const quizzes = ref([]);
        const loading = ref(false);
        const saving = ref(false);
        const selectedQuiz = ref(null);
        const showAlert = ref(false);
        const alertMessage = ref('');
        const alertVariant = ref('success');
        const deleteConfirm = ref(false);
        const expandedQuestions = ref([]);
        const showImageSearchModal = ref(false);
        const cdnFiles = ref([]);
        const imageSearchQuery = ref('');
        const imageTarget = ref(null);
        const resetStartDate = ref('');
        const resetInterval = ref(86400);
        const resettingDates = ref(false);
        const dragIndex = ref(null);
        const dragOverIndex = ref(null);
        const showUnlockDialog = ref(false);
        const unlockConfirmText = ref('');
        const quizUnlocked = ref(false);
        const showResetDialog = ref(false);
        const showJsonEditor = ref(false);
        const jsonEditorContent = ref('');
        const jsonError = ref('');
        const employers = ref([]);
        const filteredCdnFiles = computed(() => {
            if (!cdnFiles.value)
                return [];
            const query = imageSearchQuery.value.toLowerCase();
            return cdnFiles.value.filter((f) => f.fileName.toLowerCase().includes(query) &&
                ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].some(ext => f.fileName.toLowerCase().endsWith(ext)));
        });
        const quizStarted = computed(() => {
            if (!selectedQuiz.value?.startDateTime)
                return false;
            return new Date() > new Date(selectedQuiz.value.startDateTime);
        });
        const quizFinished = computed(() => {
            if (!selectedQuiz.value?.endDateTime)
                return false;
            return new Date() > new Date(selectedQuiz.value.endDateTime);
        });
        function isQuizStarted(quiz) {
            if (!quiz?.startDateTime)
                return false;
            return new Date() > new Date(quiz.startDateTime);
        }
        function isQuizFinished(quiz) {
            if (!quiz?.endDateTime)
                return false;
            return new Date() > new Date(quiz.endDateTime);
        }
        function getQuizStatus(quiz) {
            if (!isQuizStarted(quiz))
                return 'Not Started';
            if (isQuizFinished(quiz))
                return 'Finished';
            return 'Active';
        }
        function refreshQuizzes() {
            loading.value = true;
            admin.getQuizzes((data) => {
                quizzes.value = data || [];
                loading.value = false;
            }, (error) => {
                showAlertMessage(error, 'error');
                loading.value = false;
            });
        }
        function selectQuiz(quiz) {
            selectedQuiz.value = JSON.parse(JSON.stringify(quiz));
            if (!Array.isArray(selectedQuiz.value.employers))
                selectedQuiz.value.employers = [];
            expandedQuestions.value = [];
            quizUnlocked.value = false;
            // Convert dates from API format to datetime-local format
            if (selectedQuiz.value.advertiseDateTime) {
                selectedQuiz.value.advertiseDateTime = formatDateTimeFromApi(selectedQuiz.value.advertiseDateTime);
            }
            if (selectedQuiz.value.showClosedUntilDateTime) {
                selectedQuiz.value.showClosedUntilDateTime = formatDateTimeFromApi(selectedQuiz.value.showClosedUntilDateTime);
            }
            if (selectedQuiz.value.questions) {
                selectedQuiz.value.questions.forEach((q) => {
                    if (q.startDateTime)
                        q.startDateTime = formatDateTimeFromApi(q.startDateTime);
                    if (q.endDateTime)
                        q.endDateTime = formatDateTimeFromApi(q.endDateTime);
                });
            }
            // Infer quizStartDate from existing questions or quiz startDateTime
            if (!selectedQuiz.value.quizStartDate) {
                if (selectedQuiz.value.questions?.length > 0 && selectedQuiz.value.questions[0].startDateTime) {
                    selectedQuiz.value.quizStartDate = selectedQuiz.value.questions[0].startDateTime;
                }
                else if (selectedQuiz.value.startDateTime) {
                    selectedQuiz.value.quizStartDate = formatDateTimeFromApi(selectedQuiz.value.startDateTime);
                }
            }
            if (!selectedQuiz.value.questionInterval && selectedQuiz.value.questions?.length > 1) {
                const q1 = selectedQuiz.value.questions[0];
                const q2 = selectedQuiz.value.questions[1];
                if (q1.startDateTime && q2.startDateTime) {
                    const diff = new Date(q2.startDateTime).getTime() - new Date(q1.startDateTime).getTime();
                    selectedQuiz.value.questionInterval = Math.round(diff / 1000);
                }
            }
            if (!selectedQuiz.value.questionInterval) {
                selectedQuiz.value.questionInterval = 86400;
            }
            // Infer numberOfQuestions from existing questions
            if (selectedQuiz.value.questions?.length > 0) {
                selectedQuiz.value.numberOfQuestions = selectedQuiz.value.questions.length;
            }
            else if (!selectedQuiz.value.numberOfQuestions) {
                selectedQuiz.value.numberOfQuestions = 10;
            }
        }
        function newQuiz() {
            selectedQuiz.value = {
                name: '',
                description: '',
                tagLineHeader: '',
                tagLine: '',
                bgUrl: '',
                thumbUrl: '',
                termsUrl: '',
                startDateTime: '',
                endDateTime: '',
                advertiseDateTime: '',
                showClosedUntilDateTime: '',
                closedThumbUrl: '',
                finalDaySpecialImageUrl: '',
                closedDescription: '',
                advertisingHeader: '',
                advertisingDescription: '',
                streakMeterMax: 25,
                streakMeterInterval: 5,
                quizStartDate: '',
                questionInterval: 86400,
                numberOfQuestions: 10,
                employers: [],
                questions: [],
                prizes: []
            };
            expandedQuestions.value = [];
        }
        function saveQuiz() {
            // Apply JSON changes first if in JSON editor mode
            if (showJsonEditor.value) {
                if (!applyJsonToQuiz()) {
                    return;
                }
            }
            if (!selectedQuiz.value.name) {
                showAlertMessage('Quiz name is required', 'error');
                return;
            }
            // Prevent updates to started quizzes unless unlocked or finished
            if (selectedQuiz.value.id && quizStarted.value && !quizUnlocked.value && !quizFinished.value) {
                showAlertMessage('Cannot update a quiz that has already started', 'error');
                return;
            }
            // Validate advertiseDateTime - must be before quiz start date
            if (selectedQuiz.value.advertiseDateTime && selectedQuiz.value.quizStartDate) {
                if (new Date(selectedQuiz.value.advertiseDateTime) >= new Date(selectedQuiz.value.quizStartDate)) {
                    showAlertMessage('Advertise From must be before the Quiz Start Date', 'error');
                    return;
                }
            }
            // Validate showClosedUntilDateTime - must be after the last question end date
            if (selectedQuiz.value.showClosedUntilDateTime && selectedQuiz.value.quizStartDate) {
                const interval = selectedQuiz.value.questionInterval || 86400;
                const numQuestions = selectedQuiz.value.questions?.length || selectedQuiz.value.numberOfQuestions || 10;
                const startDate = new Date(selectedQuiz.value.quizStartDate);
                const lastQuestionEndDate = new Date(startDate.getTime() + (numQuestions * interval * 1000));
                if (new Date(selectedQuiz.value.showClosedUntilDateTime) <= lastQuestionEndDate) {
                    showAlertMessage('Show Closed Until must be after the last question end date', 'error');
                    return;
                }
            }
            // Create a copy for API with formatted dates
            const quizToSave = JSON.parse(JSON.stringify(selectedQuiz.value));
            // Capture local fields before removing
            const quizStartDate = quizToSave.quizStartDate;
            const questionInterval = quizToSave.questionInterval || 86400;
            const numberOfQuestions = quizToSave.numberOfQuestions || 10;
            // Remove local-only fields that the API doesn't expect
            delete quizToSave.quizStartDate;
            delete quizToSave.questionInterval;
            delete quizToSave.numberOfQuestions;
            // Set startDateTime from quizStartDate
            if (quizStartDate) {
                quizToSave.startDateTime = formatDateTimeForApi(quizStartDate);
                // Calculate endDateTime based on numberOfQuestions and interval
                const startDate = new Date(quizStartDate);
                const endDate = new Date(startDate.getTime() + (numberOfQuestions * questionInterval * 1000));
                quizToSave.endDateTime = formatDateTimeForApi(formatDateTimeLocal(endDate));
            }
            if (quizToSave.questions?.length > 0) {
                // Format question dates for API
                quizToSave.questions.forEach((q) => {
                    if (q.startDateTime)
                        q.startDateTime = formatDateTimeForApi(q.startDateTime);
                    if (q.endDateTime)
                        q.endDateTime = formatDateTimeForApi(q.endDateTime);
                });
                // Override endDateTime from last question if questions exist
                const lastQuestion = quizToSave.questions[quizToSave.questions.length - 1];
                if (lastQuestion.endDateTime) {
                    quizToSave.endDateTime = lastQuestion.endDateTime;
                }
            }
            // Format advertiseDateTime and showClosedUntilDateTime for API if set
            if (quizToSave.advertiseDateTime) {
                quizToSave.advertiseDateTime = formatDateTimeForApi(quizToSave.advertiseDateTime);
            }
            if (quizToSave.showClosedUntilDateTime) {
                quizToSave.showClosedUntilDateTime = formatDateTimeForApi(quizToSave.showClosedUntilDateTime);
            }
            // Remove empty date fields entirely (API doesn't accept null or empty strings)
            const dateFields = ['startDateTime', 'endDateTime', 'advertiseDateTime', 'showClosedUntilDateTime'];
            dateFields.forEach(field => {
                if (!quizToSave[field]) {
                    delete quizToSave[field];
                }
            });
            saving.value = true;
            if (selectedQuiz.value.id) {
                const quizId = selectedQuiz.value.id;
                admin.updateQuiz(quizId, quizToSave, () => {
                    showAlertMessage('Quiz updated successfully', 'success');
                    saving.value = false;
                    // Refresh and re-select the quiz to show updated data from API
                    admin.getQuizzes((data) => {
                        quizzes.value = data || [];
                        const updatedQuiz = quizzes.value.find((q) => q.id === quizId);
                        if (updatedQuiz) {
                            selectQuiz(updatedQuiz);
                        }
                    }, () => { });
                }, (error) => {
                    showAlertMessage(error, 'error');
                    saving.value = false;
                });
            }
            else {
                admin.createQuiz(quizToSave, (data) => {
                    showAlertMessage('Quiz created successfully', 'success');
                    saving.value = false;
                    selectedQuiz.value = data;
                    refreshQuizzes();
                }, (error) => {
                    showAlertMessage(error, 'error');
                    saving.value = false;
                });
            }
        }
        function showDeleteConfirm() {
            deleteConfirm.value = true;
        }
        function deleteQuiz() {
            if (!selectedQuiz.value?.id)
                return;
            admin.deleteQuiz(selectedQuiz.value.id, () => {
                showAlertMessage('Quiz deleted successfully', 'success');
                selectedQuiz.value = null;
                deleteConfirm.value = false;
                refreshQuizzes();
            }, (error) => {
                showAlertMessage(error, 'error');
                deleteConfirm.value = false;
            });
        }
        function confirmResetQuizDates() {
            showResetDialog.value = false;
            resetQuizDates();
        }
        function resetQuizDates() {
            if (!selectedQuiz.value?.id || !resetStartDate.value)
                return;
            resettingDates.value = true;
            // Format date for API: "2026-01-12 15:00:00.000000"
            const date = new Date(resetStartDate.value);
            const formattedDate = date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0') + ' ' +
                String(date.getHours()).padStart(2, '0') + ':' +
                String(date.getMinutes()).padStart(2, '0') + ':' +
                String(date.getSeconds()).padStart(2, '0') + '.000000';
            const quizId = selectedQuiz.value.id;
            admin.resetQuizDates(quizId, formattedDate, resetInterval.value, () => {
                showAlertMessage('Quiz dates reset successfully', 'success');
                resettingDates.value = false;
                // Refresh and re-select the quiz to show updated dates
                admin.getQuizzes((data) => {
                    quizzes.value = data || [];
                    const updatedQuiz = quizzes.value.find((q) => q.id === quizId);
                    if (updatedQuiz) {
                        selectQuiz(updatedQuiz);
                    }
                }, () => { });
            }, (error) => {
                showAlertMessage(error, 'error');
                resettingDates.value = false;
            });
        }
        // Question methods
        function toggleQuestion(index) {
            const idx = expandedQuestions.value.indexOf(index);
            if (idx > -1) {
                expandedQuestions.value.splice(idx, 1);
            }
            else {
                expandedQuestions.value.push(index);
            }
        }
        function addQuestion() {
            if (!selectedQuiz.value.questions) {
                selectedQuiz.value.questions = [];
            }
            const questionIndex = selectedQuiz.value.questions.length;
            const { startDateTime, endDateTime } = calculateQuestionDates(questionIndex);
            const newQuestion = {
                questionNumber: questionIndex + 1,
                value: '',
                dailyDescription: '',
                preAmble: '',
                answerDescription: '',
                answerExample: '',
                bgUrl: '',
                thumbUrl: '',
                startDateTime,
                endDateTime,
                correctPoints: 2,
                incorrectPoints: 1,
                answers: [
                    { value: '', isCorrect: false },
                    { value: '', isCorrect: false },
                    { value: '', isCorrect: false },
                    { value: '', isCorrect: true }
                ]
            };
            selectedQuiz.value.questions.push(newQuestion);
            expandedQuestions.value.push(selectedQuiz.value.questions.length - 1);
        }
        function generateEmptyQuestions() {
            if (!selectedQuiz.value.quizStartDate || !selectedQuiz.value.numberOfQuestions)
                return;
            const targetCount = selectedQuiz.value.numberOfQuestions;
            const currentCount = selectedQuiz.value.questions?.length || 0;
            if (targetCount <= currentCount) {
                showAlertMessage('Number of questions must be greater than current count to generate more', 'error');
                return;
            }
            if (!selectedQuiz.value.questions) {
                selectedQuiz.value.questions = [];
            }
            const newCount = targetCount - currentCount;
            for (let i = currentCount; i < targetCount; i++) {
                const { startDateTime, endDateTime } = calculateQuestionDates(i);
                selectedQuiz.value.questions.push({
                    questionNumber: i + 1,
                    value: '',
                    dailyDescription: '',
                    preAmble: '',
                    answerDescription: '',
                    answerExample: '',
                    bgUrl: '',
                    thumbUrl: '',
                    startDateTime,
                    endDateTime,
                    correctPoints: 2,
                    incorrectPoints: 1,
                    answers: [
                        { value: '', isCorrect: false },
                        { value: '', isCorrect: false },
                        { value: '', isCorrect: false },
                        { value: '', isCorrect: true }
                    ]
                });
            }
            showAlertMessage(`Generated ${newCount} new question${newCount > 1 ? 's' : ''}`, 'success');
        }
        function deleteQuestion(index) {
            selectedQuiz.value.questions.splice(index, 1);
            const expIdx = expandedQuestions.value.indexOf(index);
            if (expIdx > -1) {
                expandedQuestions.value.splice(expIdx, 1);
            }
        }
        function duplicateQuestion(index) {
            const original = selectedQuiz.value.questions[index];
            const copy = JSON.parse(JSON.stringify(original));
            // Clear ID so it gets a new one on save
            delete copy.id;
            copy.answers.forEach((a) => delete a.id);
            // Calculate correct dates for the new position at the end
            const newIndex = selectedQuiz.value.questions.length;
            const { startDateTime, endDateTime } = calculateQuestionDates(newIndex);
            copy.questionNumber = newIndex + 1;
            copy.startDateTime = startDateTime;
            copy.endDateTime = endDateTime;
            selectedQuiz.value.questions.push(copy);
            // Expand the new question
            expandedQuestions.value.push(selectedQuiz.value.questions.length - 1);
        }
        // Drag and drop methods
        function onDragStart(index, event) {
            dragIndex.value = index;
            event.dataTransfer.effectAllowed = 'move';
        }
        function onDragOver(index) {
            if (dragIndex.value !== index) {
                dragOverIndex.value = index;
            }
        }
        function onDragLeave() {
            dragOverIndex.value = null;
        }
        function onDrop(index) {
            if (dragIndex.value === null || dragIndex.value === index)
                return;
            const questions = selectedQuiz.value.questions;
            const draggedItem = questions.splice(dragIndex.value, 1)[0];
            // When dragging from lower to higher index, adjust for the removed item
            const targetIndex = dragIndex.value < index ? index - 1 : index;
            questions.splice(targetIndex, 0, draggedItem);
            // Recalculate dates based on new order
            recalculateAllQuestionDates();
            dragIndex.value = null;
            dragOverIndex.value = null;
        }
        function onDragEnd() {
            dragIndex.value = null;
            dragOverIndex.value = null;
        }
        function formatDateTimeLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day}T${hours}:${minutes}`;
        }
        function formatDateTimeForApi(dateTimeLocal) {
            if (!dateTimeLocal)
                return null;
            const date = new Date(dateTimeLocal);
            return date.getFullYear() + '-' +
                String(date.getMonth() + 1).padStart(2, '0') + '-' +
                String(date.getDate()).padStart(2, '0') + 'T' +
                String(date.getHours()).padStart(2, '0') + ':' +
                String(date.getMinutes()).padStart(2, '0') + ':' +
                String(date.getSeconds()).padStart(2, '0');
        }
        function formatDateTimeFromApi(apiDateTime) {
            if (!apiDateTime)
                return '';
            const date = new Date(apiDateTime);
            if (isNaN(date.getTime()))
                return '';
            return formatDateTimeLocal(date);
        }
        function calculateQuestionDates(questionIndex) {
            const quizStart = selectedQuiz.value.quizStartDate;
            const interval = selectedQuiz.value.questionInterval || 86400;
            if (!quizStart) {
                return { startDateTime: '', endDateTime: '' };
            }
            const baseDate = new Date(quizStart);
            const intervalMs = interval * 1000;
            const startTime = new Date(baseDate.getTime() + (questionIndex * intervalMs));
            const endTime = new Date(startTime.getTime() + intervalMs);
            return {
                startDateTime: formatDateTimeLocal(startTime),
                endDateTime: formatDateTimeLocal(endTime)
            };
        }
        function recalculateAllQuestionDates() {
            if (!selectedQuiz.value?.questions)
                return;
            selectedQuiz.value.questions.forEach((question, index) => {
                const { startDateTime, endDateTime } = calculateQuestionDates(index);
                question.startDateTime = startDateTime;
                question.endDateTime = endDateTime;
                question.questionNumber = index + 1;
            });
        }
        // Answer methods
        function addAnswer(questionIndex) {
            if (!selectedQuiz.value.questions[questionIndex].answers) {
                selectedQuiz.value.questions[questionIndex].answers = [];
            }
            selectedQuiz.value.questions[questionIndex].answers.push({
                value: '',
                isCorrect: false
            });
        }
        function deleteAnswer(questionIndex, answerIndex) {
            selectedQuiz.value.questions[questionIndex].answers.splice(answerIndex, 1);
        }
        // Prize methods
        function addPrize() {
            if (!selectedQuiz.value.prizes) {
                selectedQuiz.value.prizes = [];
            }
            selectedQuiz.value.prizes.push({
                order: selectedQuiz.value.prizes.length,
                name: '',
                description: '',
                imageUrl: '',
                quantity: 1
            });
        }
        function deletePrize(index) {
            selectedQuiz.value.prizes.splice(index, 1);
        }
        // Utility methods
        function truncate(str, length) {
            if (!str)
                return '';
            return str.length > length ? str.substring(0, length) + '...' : str;
        }
        function showAlertMessage(message, variant = 'success') {
            alertMessage.value = message;
            alertVariant.value = variant;
            showAlert.value = true;
            setTimeout(() => {
                showAlert.value = false;
            }, 5000);
        }
        function confirmUnlock() {
            if (unlockConfirmText.value.toLowerCase() === 'i am sure') {
                quizUnlocked.value = true;
                showUnlockDialog.value = false;
                unlockConfirmText.value = '';
                showAlertMessage('Quiz unlocked for editing', 'success');
            }
        }
        // Image picker methods
        function setImageTarget(type, field, questionIndex) {
            imageTarget.value = { type: type, field: field, questionIndex: questionIndex };
        }
        function openImagePicker() {
            showImageSearchModal.value = true;
            imageSearchQuery.value = '';
            loadCdnFiles();
        }
        function loadCdnFiles() {
            admin.getFiles((files) => {
                cdnFiles.value = files || [];
            });
        }
        function selectImage(file) {
            if (!imageTarget.value)
                return;
            if (imageTarget.value.type === 'quiz') {
                selectedQuiz.value[imageTarget.value.field] = file.uri;
            }
            else if (imageTarget.value.type === 'question' && imageTarget.value.questionIndex !== null) {
                selectedQuiz.value.questions[imageTarget.value.questionIndex][imageTarget.value.field] = file.uri;
            }
            showImageSearchModal.value = false;
            imageTarget.value = null;
        }
        function toggleJsonEditor() {
            jsonError.value = '';
            if (showJsonEditor.value) {
                // Switching to form view - apply JSON changes
                try {
                    const parsed = JSON.parse(jsonEditorContent.value);
                    selectedQuiz.value = parsed;
                    showJsonEditor.value = false;
                }
                catch (e) {
                    jsonError.value = 'Invalid JSON: ' + e.message;
                }
            }
            else {
                // Switching to JSON view
                jsonEditorContent.value = JSON.stringify(selectedQuiz.value, null, 2);
                showJsonEditor.value = true;
            }
        }
        function applyJsonToQuiz() {
            try {
                const parsed = JSON.parse(jsonEditorContent.value);
                selectedQuiz.value = parsed;
                jsonError.value = '';
                return true;
            }
            catch (e) {
                jsonError.value = 'Invalid JSON: ' + e.message;
                return false;
            }
        }
        onMounted(() => {
            refreshQuizzes();
            admin.getEmployers((data) => { employers.value = data || []; });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[111] || (_cache[111] = _createElementVNode("div", { class: "page-header" }, [
                    _createElementVNode("h1", null, "Quiz Administration"),
                    _createElementVNode("p", { class: "subtitle" }, "Manage quizzes, questions, and prizes")
                ], -1)),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showAlert.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["alert", `alert-${alertVariant.value}`])
                            }, [
                                _createElementVNode("span", _hoisted_2, _toDisplayString(alertMessage.value), 1),
                                _createElementVNode("button", {
                                    class: "alert-close",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showAlert.value = false))
                                }, "×")
                            ], 2))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(AdminListSection, {
                        title: "Quizzes",
                        items: quizzes.value,
                        "selected-id": selectedQuiz.value?.id,
                        loading: loading.value,
                        "search-placeholder": "Search quizzes...",
                        "empty-message": "No quizzes found",
                        "search-fields": ['name', 'description'],
                        "show-new-button": true,
                        "new-button-text": "New Quiz",
                        onSelect: selectQuiz,
                        onRefresh: refreshQuizzes,
                        onNew: newQuiz
                    }, {
                        item: _withCtx(({ item }) => [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["badge", { enabled: isQuizStarted(item) && !isQuizFinished(item), disabled: !isQuizStarted(item), finished: isQuizFinished(item) }])
                                    }, _toDisplayString(getQuizStatus(item)), 3),
                                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.questions?.length || 0) + " questions", 1)
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["items", "selected-id", "loading"]),
                    (selectedQuiz.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("h2", null, _toDisplayString(selectedQuiz.value.name || 'New Quiz'), 1),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: toggleJsonEditor
                                    }, _toDisplayString(showJsonEditor.value ? 'Form View' : 'JSON View'), 1),
                                    _createVNode(AdminHeaderActions, {
                                        loading: saving.value,
                                        "has-id": !!selectedQuiz.value.id,
                                        onSave: saveQuiz,
                                        onDelete: showDeleteConfirm,
                                        onNew: newQuiz
                                    }, null, 8, ["loading", "has-id"])
                                ])
                            ]),
                            (quizStarted.value && !quizUnlocked.value && !quizFinished.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _cache[48] || (_cache[48] = _createTextVNode(" This quiz has started and cannot be modified. ")),
                                    _createElementVNode("button", {
                                        class: "action-btn secondary unlock-btn",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (showUnlockDialog.value = true))
                                    }, "Unlock")
                                ]))
                                : _createCommentVNode("", true),
                            (showJsonEditor.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((jsonEditorContent).value = $event)),
                                        class: "json-editor-textarea",
                                        spellcheck: "false"
                                    }, null, 512), [
                                        [_vModelText, jsonEditorContent.value]
                                    ]),
                                    (jsonError.value)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(jsonError.value), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _cache[61] || (_cache[61] = _createElementVNode("h3", null, "Basic Information", -1)),
                                        _createElementVNode("div", _hoisted_16, [
                                            _cache[49] || (_cache[49] = _createElementVNode("label", null, "Name", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((selectedQuiz.value.name) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedQuiz.value.name]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _cache[50] || (_cache[50] = _createElementVNode("label", null, "Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((selectedQuiz.value.description) = $event)),
                                                class: "form-textarea",
                                                rows: "2"
                                            }, null, 512), [
                                                [_vModelText, selectedQuiz.value.description]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, [
                                                _cache[51] || (_cache[51] = _createElementVNode("label", null, "Tag Line Header", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((selectedQuiz.value.tagLineHeader) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.tagLineHeader]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                                _cache[52] || (_cache[52] = _createElementVNode("label", null, "Tag Line", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((selectedQuiz.value.tagLine) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.tagLine]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("div", _hoisted_22, [
                                                _cache[53] || (_cache[53] = _createElementVNode("label", null, "Quiz Start Date/Time", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((selectedQuiz.value.quizStartDate) = $event)),
                                                    class: "form-input",
                                                    onChange: recalculateAllQuestionDates
                                                }, null, 544), [
                                                    [_vModelText, selectedQuiz.value.quizStartDate]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_23, [
                                                _cache[54] || (_cache[54] = _createElementVNode("label", null, "Number of Questions", -1)),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((selectedQuiz.value.numberOfQuestions) = $event)),
                                                        class: "form-input",
                                                        min: "1",
                                                        onChange: recalculateAllQuestionDates
                                                    }, null, 544), [
                                                        [
                                                            _vModelText,
                                                            selectedQuiz.value.numberOfQuestions,
                                                            void 0,
                                                            { number: true }
                                                        ]
                                                    ]),
                                                    _createElementVNode("button", {
                                                        class: "action-btn secondary",
                                                        type: "button",
                                                        onClick: generateEmptyQuestions,
                                                        disabled: !selectedQuiz.value.quizStartDate
                                                    }, "Generate", 8, _hoisted_25)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("div", _hoisted_27, [
                                                _cache[55] || (_cache[55] = _createElementVNode("label", null, "Question Interval (seconds)", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((selectedQuiz.value.questionInterval) = $event)),
                                                    class: "form-input",
                                                    placeholder: "86400 = 1 day",
                                                    onChange: recalculateAllQuestionDates
                                                }, null, 544), [
                                                    [
                                                        _vModelText,
                                                        selectedQuiz.value.questionInterval,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ]),
                                                _cache[56] || (_cache[56] = _createElementVNode("span", { class: "help-text" }, "86400 = 1 day, 43200 = 12 hours", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_28, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _cache[57] || (_cache[57] = _createElementVNode("label", null, "Advertise From", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedQuiz.value.advertiseDateTime) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.advertiseDateTime]
                                                ]),
                                                _cache[58] || (_cache[58] = _createElementVNode("span", { class: "help-text" }, "When the quiz starts appearing", -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_30, [
                                                _cache[59] || (_cache[59] = _createElementVNode("label", null, "Show Closed Until", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((selectedQuiz.value.showClosedUntilDateTime) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.showClosedUntilDateTime]
                                                ]),
                                                _cache[60] || (_cache[60] = _createElementVNode("span", { class: "help-text" }, "Show as closed until this date", -1))
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_31, [
                                        _cache[67] || (_cache[67] = _createElementVNode("h3", null, "Images", -1)),
                                        _createElementVNode("div", _hoisted_32, [
                                            _cache[62] || (_cache[62] = _createElementVNode("label", null, "Background URL", -1)),
                                            _createElementVNode("div", _hoisted_33, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((selectedQuiz.value.bgUrl) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.bgUrl]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: _cache[13] || (_cache[13] = ($event) => { setImageTarget('quiz', 'bgUrl', null); openImagePicker(); })
                                                }, "Pick")
                                            ]),
                                            (selectedQuiz.value.bgUrl)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                    _createElementVNode("img", {
                                                        src: selectedQuiz.value.bgUrl,
                                                        class: "image-preview"
                                                    }, null, 8, _hoisted_35)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _cache[63] || (_cache[63] = _createElementVNode("label", null, "Thumbnail URL", -1)),
                                            _createElementVNode("div", _hoisted_37, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((selectedQuiz.value.thumbUrl) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.thumbUrl]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: _cache[15] || (_cache[15] = ($event) => { setImageTarget('quiz', 'thumbUrl', null); openImagePicker(); })
                                                }, "Pick")
                                            ]),
                                            (selectedQuiz.value.thumbUrl)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                    _createElementVNode("img", {
                                                        src: selectedQuiz.value.thumbUrl,
                                                        class: "image-preview"
                                                    }, null, 8, _hoisted_39)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_40, [
                                            _cache[64] || (_cache[64] = _createElementVNode("label", null, "Closed Thumbnail URL", -1)),
                                            _createElementVNode("div", _hoisted_41, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((selectedQuiz.value.closedThumbUrl) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.closedThumbUrl]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: _cache[17] || (_cache[17] = ($event) => { setImageTarget('quiz', 'closedThumbUrl', null); openImagePicker(); })
                                                }, "Pick")
                                            ]),
                                            (selectedQuiz.value.closedThumbUrl)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                                    _createElementVNode("img", {
                                                        src: selectedQuiz.value.closedThumbUrl,
                                                        class: "image-preview"
                                                    }, null, 8, _hoisted_43)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_44, [
                                            _cache[65] || (_cache[65] = _createElementVNode("label", null, "Final Day Special Image URL", -1)),
                                            _createElementVNode("div", _hoisted_45, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((selectedQuiz.value.finalDaySpecialImageUrl) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.finalDaySpecialImageUrl]
                                                ]),
                                                _createElementVNode("button", {
                                                    class: "action-btn",
                                                    type: "button",
                                                    onClick: _cache[19] || (_cache[19] = ($event) => { setImageTarget('quiz', 'finalDaySpecialImageUrl', null); openImagePicker(); })
                                                }, "Pick")
                                            ]),
                                            (selectedQuiz.value.finalDaySpecialImageUrl)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                    _createElementVNode("img", {
                                                        src: selectedQuiz.value.finalDaySpecialImageUrl,
                                                        class: "image-preview"
                                                    }, null, 8, _hoisted_47)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_48, [
                                            _cache[66] || (_cache[66] = _createElementVNode("label", null, "Terms URL", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((selectedQuiz.value.termsUrl) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedQuiz.value.termsUrl]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                        _cache[71] || (_cache[71] = _createElementVNode("h3", null, "Advertising", -1)),
                                        _createElementVNode("div", _hoisted_50, [
                                            _cache[68] || (_cache[68] = _createElementVNode("label", null, "Advertising Header", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((selectedQuiz.value.advertisingHeader) = $event)),
                                                class: "form-input"
                                            }, null, 512), [
                                                [_vModelText, selectedQuiz.value.advertisingHeader]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_51, [
                                            _cache[69] || (_cache[69] = _createElementVNode("label", null, "Advertising Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((selectedQuiz.value.advertisingDescription) = $event)),
                                                class: "form-textarea",
                                                rows: "2"
                                            }, null, 512), [
                                                [_vModelText, selectedQuiz.value.advertisingDescription]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                            _cache[70] || (_cache[70] = _createElementVNode("label", null, "Closed Description", -1)),
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((selectedQuiz.value.closedDescription) = $event)),
                                                class: "form-textarea",
                                                rows: "2"
                                            }, null, 512), [
                                                [_vModelText, selectedQuiz.value.closedDescription]
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                        _cache[74] || (_cache[74] = _createElementVNode("h3", null, "Settings", -1)),
                                        _createElementVNode("div", _hoisted_54, [
                                            _createElementVNode("div", _hoisted_55, [
                                                _cache[72] || (_cache[72] = _createElementVNode("label", null, "Streak Meter Max", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((selectedQuiz.value.streakMeterMax) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        selectedQuiz.value.streakMeterMax,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                                _cache[73] || (_cache[73] = _createElementVNode("label", null, "Streak Meter Interval", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "number",
                                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((selectedQuiz.value.streakMeterInterval) = $event)),
                                                    class: "form-input"
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        selectedQuiz.value.streakMeterInterval,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("details", _hoisted_57, [
                                        _createElementVNode("summary", null, [
                                            _createElementVNode("h3", null, "Employers (" + _toDisplayString(selectedQuiz.value.employers?.length || 0) + ")", 1)
                                        ]),
                                        _cache[75] || (_cache[75] = _createElementVNode("span", { class: "help-text" }, "Leave all unticked to show this quiz to every employer", -1)),
                                        _createElementVNode("div", _hoisted_58, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employers.value, (employer) => {
                                                return (_openBlock(), _createElementBlock("label", {
                                                    key: employer.id,
                                                    class: "checkbox-label"
                                                }, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "checkbox",
                                                        value: employer.id,
                                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((selectedQuiz.value.employers) = $event))
                                                    }, null, 8, _hoisted_59), [
                                                        [_vModelCheckbox, selectedQuiz.value.employers]
                                                    ]),
                                                    _createTextVNode(" " + _toDisplayString(employer.name), 1)
                                                ]));
                                            }), 128))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_60, [
                                        _createElementVNode("div", _hoisted_61, [
                                            _createElementVNode("h3", null, "Questions (" + _toDisplayString(selectedQuiz.value.questions?.length || 0) + ")", 1),
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: addQuestion
                                            }, "+ Add Question")
                                        ]),
                                        (selectedQuiz.value.questions && selectedQuiz.value.questions.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedQuiz.value.questions, (question, qIndex) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: question.id || qIndex,
                                                        class: _normalizeClass(["question-container", { dragging: dragIndex.value === qIndex, 'drag-over': dragOverIndex.value === qIndex }]),
                                                        draggable: "true",
                                                        onDragstart: ($event) => (onDragStart(qIndex, $event)),
                                                        onDragover: _withModifiers(($event) => (onDragOver(qIndex)), ["prevent"]),
                                                        onDragleave: onDragLeave,
                                                        onDrop: ($event) => (onDrop(qIndex)),
                                                        onDragend: onDragEnd
                                                    }, [
                                                        _createElementVNode("div", {
                                                            class: "question-header",
                                                            onClick: ($event) => (toggleQuestion(qIndex))
                                                        }, [
                                                            _createElementVNode("span", {
                                                                class: "drag-handle",
                                                                onMousedown: _cache[27] || (_cache[27] = _withModifiers(() => { }, ["stop"])),
                                                                title: "Drag to reorder"
                                                            }, "☰", 32),
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass(["expand-icon", { rotated: expandedQuestions.value.includes(qIndex) }])
                                                            }, ">", 2),
                                                            _createElementVNode("span", _hoisted_65, "Q" + _toDisplayString(question.questionNumber || qIndex + 1), 1),
                                                            _createElementVNode("span", _hoisted_66, _toDisplayString(truncate(question.value, 60)), 1),
                                                            _createElementVNode("button", {
                                                                class: "action-btn secondary small",
                                                                onClick: _withModifiers(($event) => (duplicateQuestion(qIndex)), ["stop"])
                                                            }, "Duplicate", 8, _hoisted_67),
                                                            _createElementVNode("button", {
                                                                class: "action-btn danger small",
                                                                onClick: _withModifiers(($event) => (deleteQuestion(qIndex)), ["stop"])
                                                            }, "Delete", 8, _hoisted_68)
                                                        ], 8, _hoisted_64),
                                                        _createVNode(_Transition, { name: "expand" }, {
                                                            default: _withCtx(() => [
                                                                (expandedQuestions.value.includes(qIndex))
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                                                        _createElementVNode("div", _hoisted_70, [
                                                                            _createElementVNode("div", _hoisted_71, [
                                                                                _cache[76] || (_cache[76] = _createElementVNode("label", null, "Question Number", -1)),
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    type: "number",
                                                                                    "onUpdate:modelValue": ($event) => ((question.questionNumber) = $event),
                                                                                    class: "form-input"
                                                                                }, null, 8, _hoisted_72), [
                                                                                    [
                                                                                        _vModelText,
                                                                                        question.questionNumber,
                                                                                        void 0,
                                                                                        { number: true }
                                                                                    ]
                                                                                ])
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_73, [
                                                                                _cache[77] || (_cache[77] = _createElementVNode("label", null, "Correct Points", -1)),
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    type: "number",
                                                                                    "onUpdate:modelValue": ($event) => ((question.correctPoints) = $event),
                                                                                    class: "form-input"
                                                                                }, null, 8, _hoisted_74), [
                                                                                    [
                                                                                        _vModelText,
                                                                                        question.correctPoints,
                                                                                        void 0,
                                                                                        { number: true }
                                                                                    ]
                                                                                ])
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_75, [
                                                                                _cache[78] || (_cache[78] = _createElementVNode("label", null, "Incorrect Points", -1)),
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    type: "number",
                                                                                    "onUpdate:modelValue": ($event) => ((question.incorrectPoints) = $event),
                                                                                    class: "form-input"
                                                                                }, null, 8, _hoisted_76), [
                                                                                    [
                                                                                        _vModelText,
                                                                                        question.incorrectPoints,
                                                                                        void 0,
                                                                                        { number: true }
                                                                                    ]
                                                                                ])
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_77, [
                                                                            _cache[79] || (_cache[79] = _createElementVNode("label", null, "Question", -1)),
                                                                            _withDirectives(_createElementVNode("textarea", {
                                                                                "onUpdate:modelValue": ($event) => ((question.value) = $event),
                                                                                class: "form-textarea",
                                                                                rows: "2"
                                                                            }, null, 8, _hoisted_78), [
                                                                                [_vModelText, question.value]
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_79, [
                                                                            _cache[80] || (_cache[80] = _createElementVNode("label", null, "Daily Description", -1)),
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                type: "text",
                                                                                "onUpdate:modelValue": ($event) => ((question.dailyDescription) = $event),
                                                                                class: "form-input"
                                                                            }, null, 8, _hoisted_80), [
                                                                                [_vModelText, question.dailyDescription]
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_81, [
                                                                            _cache[81] || (_cache[81] = _createElementVNode("label", null, "Pre-amble (joke/intro)", -1)),
                                                                            _withDirectives(_createElementVNode("textarea", {
                                                                                "onUpdate:modelValue": ($event) => ((question.preamble) = $event),
                                                                                class: "form-textarea",
                                                                                rows: "2"
                                                                            }, null, 8, _hoisted_82), [
                                                                                [_vModelText, question.preamble]
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_83, [
                                                                            _cache[82] || (_cache[82] = _createElementVNode("label", null, "Answer Description", -1)),
                                                                            _withDirectives(_createElementVNode("textarea", {
                                                                                "onUpdate:modelValue": ($event) => ((question.answerDescription) = $event),
                                                                                class: "form-textarea",
                                                                                rows: "2"
                                                                            }, null, 8, _hoisted_84), [
                                                                                [_vModelText, question.answerDescription]
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_85, [
                                                                            _cache[83] || (_cache[83] = _createElementVNode("label", null, "Answer Example", -1)),
                                                                            _withDirectives(_createElementVNode("input", {
                                                                                type: "text",
                                                                                "onUpdate:modelValue": ($event) => ((question.answerExample) = $event),
                                                                                class: "form-input"
                                                                            }, null, 8, _hoisted_86), [
                                                                                [_vModelText, question.answerExample]
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_87, [
                                                                            _createElementVNode("div", _hoisted_88, [
                                                                                _cache[84] || (_cache[84] = _createElementVNode("label", null, "Start Date/Time (auto-calculated)", -1)),
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    type: "datetime-local",
                                                                                    "onUpdate:modelValue": ($event) => ((question.startDateTime) = $event),
                                                                                    class: "form-input",
                                                                                    disabled: ""
                                                                                }, null, 8, _hoisted_89), [
                                                                                    [_vModelText, question.startDateTime]
                                                                                ])
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_90, [
                                                                                _cache[85] || (_cache[85] = _createElementVNode("label", null, "End Date/Time (auto-calculated)", -1)),
                                                                                _withDirectives(_createElementVNode("input", {
                                                                                    type: "datetime-local",
                                                                                    "onUpdate:modelValue": ($event) => ((question.endDateTime) = $event),
                                                                                    class: "form-input",
                                                                                    disabled: ""
                                                                                }, null, 8, _hoisted_91), [
                                                                                    [_vModelText, question.endDateTime]
                                                                                ])
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_92, [
                                                                            _createElementVNode("div", _hoisted_93, [
                                                                                _cache[86] || (_cache[86] = _createElementVNode("label", null, "Background URL", -1)),
                                                                                _createElementVNode("div", _hoisted_94, [
                                                                                    _withDirectives(_createElementVNode("input", {
                                                                                        type: "text",
                                                                                        "onUpdate:modelValue": ($event) => ((question.bgUrl) = $event),
                                                                                        class: "form-input"
                                                                                    }, null, 8, _hoisted_95), [
                                                                                        [_vModelText, question.bgUrl]
                                                                                    ]),
                                                                                    _createElementVNode("button", {
                                                                                        class: "action-btn",
                                                                                        type: "button",
                                                                                        onClick: ($event) => { setImageTarget('question', 'bgUrl', qIndex); openImagePicker(); }
                                                                                    }, "Pick", 8, _hoisted_96)
                                                                                ]),
                                                                                (question.bgUrl)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                                                                        _createElementVNode("img", {
                                                                                            src: question.bgUrl,
                                                                                            class: "image-preview"
                                                                                        }, null, 8, _hoisted_98)
                                                                                    ]))
                                                                                    : _createCommentVNode("", true)
                                                                            ]),
                                                                            _createElementVNode("div", _hoisted_99, [
                                                                                _cache[87] || (_cache[87] = _createElementVNode("label", null, "Thumbnail URL", -1)),
                                                                                _createElementVNode("div", _hoisted_100, [
                                                                                    _withDirectives(_createElementVNode("input", {
                                                                                        type: "text",
                                                                                        "onUpdate:modelValue": ($event) => ((question.thumbUrl) = $event),
                                                                                        class: "form-input"
                                                                                    }, null, 8, _hoisted_101), [
                                                                                        [_vModelText, question.thumbUrl]
                                                                                    ]),
                                                                                    _createElementVNode("button", {
                                                                                        class: "action-btn",
                                                                                        type: "button",
                                                                                        onClick: ($event) => { setImageTarget('question', 'thumbUrl', qIndex); openImagePicker(); }
                                                                                    }, "Pick", 8, _hoisted_102)
                                                                                ]),
                                                                                (question.thumbUrl)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                                                        _createElementVNode("img", {
                                                                                            src: question.thumbUrl,
                                                                                            class: "image-preview"
                                                                                        }, null, 8, _hoisted_104)
                                                                                    ]))
                                                                                    : _createCommentVNode("", true)
                                                                            ])
                                                                        ]),
                                                                        _createElementVNode("div", _hoisted_105, [
                                                                            _cache[89] || (_cache[89] = _createElementVNode("h4", null, "Answers", -1)),
                                                                            _createElementVNode("div", _hoisted_106, [
                                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer, aIndex) => {
                                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                                        key: answer.id || aIndex,
                                                                                        class: _normalizeClass(["answer-row", { correct: answer.isCorrect }])
                                                                                    }, [
                                                                                        _withDirectives(_createElementVNode("input", {
                                                                                            type: "text",
                                                                                            "onUpdate:modelValue": ($event) => ((answer.value) = $event),
                                                                                            class: "form-input answer-input",
                                                                                            placeholder: "Answer text..."
                                                                                        }, null, 8, _hoisted_107), [
                                                                                            [_vModelText, answer.value]
                                                                                        ]),
                                                                                        _createElementVNode("label", _hoisted_108, [
                                                                                            _withDirectives(_createElementVNode("input", {
                                                                                                type: "checkbox",
                                                                                                "onUpdate:modelValue": ($event) => ((answer.isCorrect) = $event)
                                                                                            }, null, 8, _hoisted_109), [
                                                                                                [_vModelCheckbox, answer.isCorrect]
                                                                                            ]),
                                                                                            _cache[88] || (_cache[88] = _createTextVNode(" Correct "))
                                                                                        ]),
                                                                                        _createElementVNode("button", {
                                                                                            class: "action-btn danger small",
                                                                                            onClick: ($event) => (deleteAnswer(qIndex, aIndex))
                                                                                        }, "X", 8, _hoisted_110)
                                                                                    ], 2));
                                                                                }), 128))
                                                                            ]),
                                                                            ((question.answers?.length || 0) < 4)
                                                                                ? (_openBlock(), _createElementBlock("button", {
                                                                                    key: 0,
                                                                                    class: "action-btn secondary small",
                                                                                    onClick: ($event) => (addAnswer(qIndex))
                                                                                }, "+ Add Answer", 8, _hoisted_111))
                                                                                : _createCommentVNode("", true)
                                                                        ])
                                                                    ]))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ], 42, _hoisted_63));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_112, "No questions yet. Click \"Add Question\" to create one."))
                                    ]),
                                    _createElementVNode("div", _hoisted_113, [
                                        _createElementVNode("div", _hoisted_114, [
                                            _createElementVNode("h3", null, "Prizes (" + _toDisplayString(selectedQuiz.value.prizes?.length || 0) + ")", 1),
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: addPrize
                                            }, "+ Add Prize")
                                        ]),
                                        (selectedQuiz.value.prizes && selectedQuiz.value.prizes.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                _createElementVNode("table", null, [
                                                    _cache[90] || (_cache[90] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "Order"),
                                                            _createElementVNode("th", null, "Name"),
                                                            _createElementVNode("th", null, "Description"),
                                                            _createElementVNode("th", null, "Quantity"),
                                                            _createElementVNode("th", null, "Actions")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedQuiz.value.prizes, (prize, pIndex) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                                key: prize.id || pIndex
                                                            }, [
                                                                _createElementVNode("td", null, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "number",
                                                                        "onUpdate:modelValue": ($event) => ((prize.order) = $event),
                                                                        class: "form-input small"
                                                                    }, null, 8, _hoisted_116), [
                                                                        [
                                                                            _vModelText,
                                                                            prize.order,
                                                                            void 0,
                                                                            { number: true }
                                                                        ]
                                                                    ])
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "text",
                                                                        "onUpdate:modelValue": ($event) => ((prize.name) = $event),
                                                                        class: "form-input"
                                                                    }, null, 8, _hoisted_117), [
                                                                        [_vModelText, prize.name]
                                                                    ])
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "text",
                                                                        "onUpdate:modelValue": ($event) => ((prize.description) = $event),
                                                                        class: "form-input"
                                                                    }, null, 8, _hoisted_118), [
                                                                        [_vModelText, prize.description]
                                                                    ])
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    _withDirectives(_createElementVNode("input", {
                                                                        type: "number",
                                                                        "onUpdate:modelValue": ($event) => ((prize.quantity) = $event),
                                                                        class: "form-input small"
                                                                    }, null, 8, _hoisted_119), [
                                                                        [
                                                                            _vModelText,
                                                                            prize.quantity,
                                                                            void 0,
                                                                            { number: true }
                                                                        ]
                                                                    ])
                                                                ]),
                                                                _createElementVNode("td", null, [
                                                                    _createElementVNode("button", {
                                                                        class: "action-btn danger small",
                                                                        onClick: ($event) => (deletePrize(pIndex))
                                                                    }, "Delete", 8, _hoisted_120)
                                                                ])
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_121, "No prizes yet. Click \"Add Prize\" to create one."))
                                    ]),
                                    _createElementVNode("div", _hoisted_122, [
                                        _cache[95] || (_cache[95] = _createElementVNode("h3", null, "Scheduling", -1)),
                                        _createElementVNode("div", _hoisted_123, [
                                            _createElementVNode("div", _hoisted_124, [
                                                _cache[91] || (_cache[91] = _createElementVNode("label", null, "Start Date/Time", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((selectedQuiz.value.startDateTime) = $event)),
                                                    class: "form-input",
                                                    disabled: ""
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.startDateTime]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_125, [
                                                _cache[92] || (_cache[92] = _createElementVNode("label", null, "End Date/Time", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((selectedQuiz.value.endDateTime) = $event)),
                                                    class: "form-input",
                                                    disabled: ""
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.endDateTime]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_126, [
                                            _createElementVNode("div", _hoisted_127, [
                                                _cache[93] || (_cache[93] = _createElementVNode("label", null, "Advertise From", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((selectedQuiz.value.advertiseDateTime) = $event)),
                                                    class: "form-input",
                                                    disabled: ""
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.advertiseDateTime]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_128, [
                                                _cache[94] || (_cache[94] = _createElementVNode("label", null, "Show Closed Until", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "datetime-local",
                                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((selectedQuiz.value.showClosedUntilDateTime) = $event)),
                                                    class: "form-input",
                                                    disabled: ""
                                                }, null, 512), [
                                                    [_vModelText, selectedQuiz.value.showClosedUntilDateTime]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (selectedQuiz.value.id)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                            _cache[99] || (_cache[99] = _createElementVNode("h3", null, "Reset Quiz Dates", -1)),
                                            _cache[100] || (_cache[100] = _createElementVNode("p", { class: "section-description" }, "Restart the quiz with new dates for all questions.", -1)),
                                            _createElementVNode("div", _hoisted_130, [
                                                _createElementVNode("div", _hoisted_131, [
                                                    _cache[96] || (_cache[96] = _createElementVNode("label", null, "New Start Date/Time", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "datetime-local",
                                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((resetStartDate).value = $event)),
                                                        class: "form-input"
                                                    }, null, 512), [
                                                        [_vModelText, resetStartDate.value]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_132, [
                                                    _cache[97] || (_cache[97] = _createElementVNode("label", null, "Interval (seconds)", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((resetInterval).value = $event)),
                                                        class: "form-input",
                                                        placeholder: "86400 = 1 day"
                                                    }, null, 512), [
                                                        [
                                                            _vModelText,
                                                            resetInterval.value,
                                                            void 0,
                                                            { number: true }
                                                        ]
                                                    ]),
                                                    _cache[98] || (_cache[98] = _createElementVNode("span", { class: "help-text" }, "86400 = 1 day", -1))
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                class: "action-btn warning",
                                                onClick: _cache[34] || (_cache[34] = ($event) => (showResetDialog.value = true)),
                                                disabled: resettingDates.value || !resetStartDate.value || (quizStarted.value && !quizUnlocked.value && !quizFinished.value)
                                            }, _toDisplayString(resettingDates.value ? 'Resetting...' : 'Reset All Question Dates'), 9, _hoisted_133),
                                            (quizStarted.value && !quizUnlocked.value && !quizFinished.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_134, "Quiz active - cannot reset dates."))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_135, _cache[101] || (_cache[101] = [
                            _createElementVNode("p", null, "Select a quiz to view details or create a new one", -1)
                        ])))
                ]),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (deleteConfirm.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[38] || (_cache[38] = ($event) => (deleteConfirm.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog",
                                    onClick: _cache[37] || (_cache[37] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_136, [
                                        _cache[102] || (_cache[102] = _createElementVNode("h3", null, "Confirm Delete", -1)),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: _cache[35] || (_cache[35] = ($event) => (deleteConfirm.value = false))
                                        }, "×")
                                    ]),
                                    _createElementVNode("div", _hoisted_137, [
                                        _createElementVNode("p", null, [
                                            _cache[103] || (_cache[103] = _createTextVNode("Are you sure you want to delete ")),
                                            _createElementVNode("strong", null, _toDisplayString(selectedQuiz.value?.name), 1),
                                            _cache[104] || (_cache[104] = _createTextVNode("?"))
                                        ]),
                                        _cache[105] || (_cache[105] = _createElementVNode("p", null, "This action cannot be undone.", -1))
                                    ]),
                                    _createElementVNode("div", _hoisted_138, [
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: _cache[36] || (_cache[36] = ($event) => (deleteConfirm.value = false))
                                        }, "Cancel"),
                                        _createElementVNode("button", {
                                            class: "action-btn danger",
                                            onClick: deleteQuiz
                                        }, "Delete")
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                        (showImageSearchModal.value)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "modal-backdrop",
                                onClick: _cache[42] || (_cache[42] = ($event) => (showImageSearchModal.value = false))
                            }, [
                                _createElementVNode("div", {
                                    class: "modal-dialog modal-large",
                                    onClick: _cache[41] || (_cache[41] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_139, [
                                        _cache[106] || (_cache[106] = _createElementVNode("h3", null, "Select an Image", -1)),
                                        _createElementVNode("button", {
                                            class: "modal-close",
                                            onClick: _cache[39] || (_cache[39] = ($event) => (showImageSearchModal.value = false))
                                        }, "×")
                                    ]),
                                    _createElementVNode("div", _hoisted_140, [
                                        _createElementVNode("div", _hoisted_141, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event) => ((imageSearchQuery).value = $event)),
                                                type: "text",
                                                placeholder: "Search images...",
                                                class: "search-input"
                                            }, null, 512), [
                                                [_vModelText, imageSearchQuery.value]
                                            ])
                                        ]),
                                        (cdnFiles.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCdnFiles.value, (file) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: file.fileName,
                                                        class: "file-card",
                                                        onClick: ($event) => (selectImage(file))
                                                    }, [
                                                        _createElementVNode("div", _hoisted_144, [
                                                            _createElementVNode("img", {
                                                                src: file.uri,
                                                                alt: file.fileName
                                                            }, null, 8, _hoisted_145)
                                                        ]),
                                                        _createElementVNode("div", _hoisted_146, [
                                                            _createElementVNode("div", {
                                                                class: "file-card-name",
                                                                title: file.fileName
                                                            }, _toDisplayString(file.fileName), 9, _hoisted_147)
                                                        ])
                                                    ], 8, _hoisted_143));
                                                }), 128))
                                            ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_148, _cache[107] || (_cache[107] = [
                                                _createElementVNode("p", null, "No images found in CDN.", -1)
                                            ])))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(MGDialog, {
                    modelValue: showUnlockDialog.value,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((showUnlockDialog).value = $event)),
                    title: "Unlock Started Quiz",
                    "max-width": "400px",
                    "content-height": "auto"
                }, {
                    content: _withCtx(() => [
                        _cache[108] || (_cache[108] = _createElementVNode("p", { class: "unlock-warning" }, "This quiz has already started. Modifying it may cause issues for users who have already participated.", -1)),
                        _cache[109] || (_cache[109] = _createElementVNode("p", null, [
                            _createTextVNode("Type "),
                            _createElementVNode("strong", null, "i am sure"),
                            _createTextVNode(" to unlock:")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((unlockConfirmText).value = $event)),
                            class: "form-input",
                            placeholder: "Type here...",
                            onKeyup: _withKeys(confirmUnlock, ["enter"])
                        }, null, 544), [
                            [_vModelText, unlockConfirmText.value]
                        ])
                    ]),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[44] || (_cache[44] = ($event) => { showUnlockDialog.value = false; unlockConfirmText.value = ''; })
                        }, "Cancel"),
                        _createElementVNode("button", {
                            class: "action-btn danger",
                            onClick: confirmUnlock,
                            disabled: unlockConfirmText.value.toLowerCase() !== 'i am sure'
                        }, " Unlock ", 8, _hoisted_149)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showResetDialog.value,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((showResetDialog).value = $event)),
                    title: "Reset Quiz Dates",
                    "max-width": "450px",
                    "content-height": "auto"
                }, {
                    content: _withCtx(() => _cache[110] || (_cache[110] = [
                        _createElementVNode("p", { class: "unlock-warning" }, "Warning: This will reset all question dates and delete any answers already submitted by users.", -1),
                        _createElementVNode("p", null, "This action cannot be undone. Are you sure you want to proceed?", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createElementVNode("button", {
                            class: "action-btn secondary",
                            onClick: _cache[46] || (_cache[46] = ($event) => (showResetDialog.value = false))
                        }, "Cancel"),
                        _createElementVNode("button", {
                            class: "action-btn danger",
                            onClick: confirmResetQuizDates
                        }, "Reset Dates")
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
